import React from 'react';
import { useParams } from 'react-router-dom';
import CoursePageTemplate from '../components/CoursePageTemplate';

function CoursePage() {
  const { courseId } = useParams();
  return <CoursePageTemplate courseId={courseId} />;
}

export default CoursePage;
